import React from 'react';
import cn from 'classnames';
import { useDeviceType } from '@cian/ui-kit';

import * as styles from './styles.css';

/**
 * h2 с этими стилями спользуется в большинстве секций, но не во всех.
 * Если стили не подходят под конкретную секцию, лучше написать свой h2 с нуля
 */
export const H2: React.FC<{ children: string; className?: string }> = props => {
  const deviceType = useDeviceType();

  return <h2 className={cn(styles['heading'], styles[deviceType], props.className)}>{props.children}</h2>;
};
